export default __webpack_public_path__ + "static/step-three-c1ba2ad188767eacb938cc535d8869ae.svg";